import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';


import { GridMediaViewerComponent } from './grid-media-viewer.component';
import { FileRendererModule } from "../file-renderer/file-renderer.module";

@NgModule({
  declarations: [GridMediaViewerComponent],
  imports: [
	CommonModule,
	FileRendererModule,
	MatIconModule
  ],
  exports:[GridMediaViewerComponent]
})
export class GridMediaViewerModule { }
